<template>
  <div class="relative border border-black">
    <section class="relative md:pt-24 md:pb-36 pt-16 pb-24 bg-bsd-700">
      <div class="container">
        <div class="grid grid-cols-1 pb-8 text-center">
          <h3 class="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold text-white">Choisissez votre grille Tarifaire</h3>

          <p class="text-slate-400 max-w-xl mx-auto text-white/70">Commencer dès aujourd'hui, <b>Transformez</b> votre entreprise avec des informations client en <b>temps réel.</b></p>
        </div>
      </div>
    </section>

    <section class="relative md:py-24 py-16 bg-gray-50 dark:bg-slate-800">
      <div class="container">
        <div class="grid grid-cols-1">
          <div class="relative z-2 transition-all duration-500 ease-in-out sm:-mt-[200px] -mt-[140px] m-0">
            <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[30px]">
              <!-- first pricing -->
              <div class="group shadow-sm relative rounded-md overflow-hidden hover:shadow-xl dark:hover:shadow-gray-700 bg-white dark:bg-slate-900 text-center transition-all duration-500 ease-in-out h-fit hover:scale-105">
                <span v-if="grille1.promotion.pourcentage !== 0" class="absolute -right-12 -top-[8px] rotate-[45deg] w-44 h-20 pt-6 px-2 pb-0 flex items-center justify-center text-white bg-amber-500 font-semibold text-sm">
                  Remise de <br />
                  {{ grille1.promotion.pourcentage }} %
                </span>

                <div class="p-6 py-8 border-b border-gray-100 dark:border-gray-700">
                  <h5 class="text-lg font-semibold uppercase">{{ grille1.nom }}</h5>
                  <div class="text-slate-400 mt-4">
                    <b class="text-black dark:text-white"> Type : </b>
                    {{ grille1.type }} <br />{{ grille1.description }}
                  </div>
                </div>

                <div class="p-6 hosting-price">
                  <ul class="flex justify-center lg:space-x-1 xl:space-x-2 text-black dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-full">
                    <li class="inline-block">
                      <button @click="activeTabOne1(grille1.id, grille1.type, 1)" class="px-2 py-1 text-xs font-semibold rounded-full w-full text-slate-400 transition-all duration-500 ease-in-out" :class="{ togleBg: grille1.togle1 }">
                        {{ Month.mois }}
                      </button>
                    </li>
                    <li class="inline-block">
                      <button @click="activeTabTwo1(grille1.id, grille1.type, 3)" class="px-2 py-1 text-xs font-semibold rounded-full w-full text-slate-400 transition-all duration-500 ease-in-out" :class="{ togleBg: grille1.togle2 }">
                        {{ Month.trimestre }}
                      </button>
                    </li>
                    <li class="inline-block">
                      <button @click="activeTabThree1(grille1.id, grille1.type, 6)" class="px-2 py-1 text-xs font-semibold rounded-full w-full text-slate-400 transition-all duration-500 ease-in-out" :class="{ togleBg: grille1.togle3 }">
                        {{ Month.semestre }}
                      </button>
                    </li>
                    <li class="inline-block">
                      <button @click="activeTabFour1(grille1.id, grille1.type, 12)" class="px-2 py-1 text-xs font-semibold rounded-full w-full text-slate-400 transition-all duration-500 ease-in-out" :class="{ togleBg: grille1.togle4 }">
                        {{ Month.year }}
                      </button>
                    </li>
                    <li class="inline-block">
                      <button @click="activeTabFive1(grille1.id, grille1.type, 24)" class="px-2 py-1 text-xs font-semibold rounded-full w-full text-slate-400 transition-all duration-500 ease-in-out" :class="{ togleBg: grille1.togle5 }">
                        {{ Month.twoYear }}
                      </button>
                    </li>
                  </ul>

                  <!-- <ul
                  class="inline-block flex-wrap justify-center text-center p-1 bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-full"
                  id="myTabone" data-tabs-toggle="#StarterContent" role="tablist">


                  <li role="presentation" class="inline-block">
                    <button
                      class="px-4 py-1 text-sm font-semibold rounded-full w-full transition-all duration-500 ease-in-out text-white bg-bsd-700"
                      id="start-month-tab" data-tabs-target="#start-month" type="button" role="tab"
                      aria-controls="start-month" aria-selected="true">{{ Month.monthly }}</button>
                  </li>
                  <li role="presentation" class="inline-block">
                    <button
                      class="px-4 py-1 text-sm font-semibold rounded-full w-full transition-all duration-500 ease-in-out"
                      id="start-year-tab" data-tabs-target="#start-year" type="button" role="tab"
                      aria-controls="start-year" aria-selected="false">{{ Month.yearly }}</button>
                  </li>
                </ul> -->

                  <div id="StarterContent" class="mt-6">
                    <div class="" id="start-month" role="tabpanel" aria-labelledby="start-month-tab">
                      <div class="flex justify-center">
                        <span class="text-sm text-slate-400 font-semibold">{{ Devises.af }}</span>
                        <span v-if="grille1.type == 'kit'" class="text-3xl font-semibold mx-1">{{ prixKiT }}</span>

                        <span v-else-if="grille1.type == 'qr'" class="text-3xl font-semibold mx-1">{{ prixQr }}</span>

                        <span v-else-if="grille1.type == 'tablette'" class="text-3xl font-semibold mx-1">{{ prixTablette2 }} </span>

                        <span class="text-sm text-slate-400 font-semibold self-end">/{{ Month.month }}</span>
                      </div>
                    </div>
                    <div class="hidden" id="start-year" role="tabpanel" aria-labelledby="start-year-tab">
                      <div class="flex justify-center">
                        <span class="text-sm text-slate-400 font-semibold"></span>
                        <span class="text-3xl font-semibold mx-1">15.99</span>
                        <span class="text-sm text-slate-400 font-semibold self-end">/{{ Month.year }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="mt-6">
                    <button @click="goToPayment(grille1.id)" class="btn bg-bsd-700/5 hover:bg-bsd-700 border-bsd--blue-700/10 hover:border-bsd--blue-700 text-bsd-700 hover:text-black rounded-md">{{ DataBtn.cart }}</button>
                  </div>
                </div>

                <div class="py-3 px-2 bg-gray-50 dark:bg-slate-800">
                  <p class="text-black mb-0">{{ grille1.texte }} <b class="text-black dark:text-white"></b></p>
                </div>

                <div class="h-40 p-6 border-b border-gray-100 dark:border-gray-700 text-left">
                  <ul class="list-none">
                    <li v-for="contenu in grille1.contenu" class="text-slate-400 my-1">
                      <i class="uil uil-check mr-2 text-emerald-600"></i> <b class="text-black dark:text-white"> {{ contenu.qut }} </b> {{ contenu.type }} pour {{ contenu.mois }} mois
                    </li>
                  </ul>
                </div>

                <!-- <div class="p-4">
                <a href="page-services.html"
                  class="btn btn-link text-bsd-700 hover:text-bsd-700 after:bg-bsd-700 duration-500 ease-in-out">Read
                  More <i class="uil uil-angle-right-b align-middle"></i></a>
              </div> -->
              </div>
              <!-- End Price Table -->

              <!-- second pricing -->
              <div class="group relative rounded-md overflow-hidden hover:shadow-xl dark:shadow-gray-800 hover:shadow-indigo-600 border-[3px] border-bsd--blue-700 bg-white dark:bg-slate-900 text-center transition-all duration-500 ease-in-out _hover:scale-105">
                <span v-if="grille2.promotion.pourcentage !== 0" class="absolute -right-12 -top-[8px] rotate-[45deg] w-44 h-20 pt-6 px-2 pb-0 flex items-center justify-center text-white bg-amber-500 font-semibold text-sm">
                  Remise de <br />
                  {{ grille2.promotion.pourcentage }} %
                </span>

                <div class="p-6 py-8 border-b border-gray-100 dark:border-gray-700">
                  <h5 class="text-lg font-semibold uppercase">{{ grille2.nom }}</h5>
                  <div class="text-slate-400 mt-4">
                    <b class="text-black dark:text-white"> Type : </b>
                    {{ grille2.type }} <br />{{ grille2.description }}
                  </div>
                </div>

                <div class="p-6 hosting-price">
                  <ul class="flex justify-center space-x-2 text-black dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-full">
                    <li class="inline-block">
                      <button @click="activeTabOne2(grille2.id, grille2.type, 1)" class="px-2 py-1 text-xs font-semibold rounded-full w-full text-slate-400 transition-all duration-500 ease-in-out" :class="{ togleBg: grille2.togle1 }">
                        {{ Month.mois }}
                      </button>
                    </li>
                    <li class="inline-block">
                      <button @click="activeTabTwo2(grille2.id, grille2.type, 3)" class="px-2 py-1 text-xs font-semibold rounded-full w-full text-slate-400 transition-all duration-500 ease-in-out" :class="{ togleBg: grille2.togle2 }">
                        {{ Month.trimestre }}
                      </button>
                    </li>
                    <li class="inline-block">
                      <button @click="activeTabThree2(grille2.id, grille2.type, 6)" class="px-2 py-1 text-xs font-semibold rounded-full w-full text-slate-400 transition-all duration-500 ease-in-out" :class="{ togleBg: grille2.togle3 }">
                        {{ Month.semestre }}
                      </button>
                    </li>
                    <li class="inline-block">
                      <button @click="activeTabFour2(grille2.id, grille2.type, 12)" class="px-2 py-1 text-xs font-semibold rounded-full w-full text-slate-400 transition-all duration-500 ease-in-out" :class="{ togleBg: grille2.togle4 }">
                        {{ Month.year }}
                      </button>
                    </li>
                    <li class="inline-block">
                      <button @click="activeTabFive2(grille2.id, grille2.type, 24)" class="px-2 py-1 text-xs font-semibold rounded-full w-full text-slate-400 transition-all duration-500 ease-in-out" :class="{ togleBg: grille2.togle5 }">
                        {{ Month.twoYear }}
                      </button>
                    </li>
                  </ul>

                  <div id="PremiumContent" class="mt-6">
                    <div class="" id="start-month" role="tabpanel" aria-labelledby="start-month-tab">
                      <div class="flex justify-center">
                        <span class="text-sm text-slate-400 font-semibold">{{ Devises.af }}</span>
                        <span v-if="grille2.type == 'kit'" class="text-3xl font-semibold mx-1">{{ prixKiT }}</span>

                        <span v-else-if="grille2.type == 'qr'" class="text-3xl font-semibold mx-1">{{ prixQr }}</span>

                        <span v-else-if="grille2.type == 'tablette'" class="text-3xl font-semibold mx-1">{{ prixTablette }}</span> <span class="text-sm text-slate-400 font-semibold self-end">/{{ Month.month }}</span>
                      </div>
                    </div>
                    <div class="hidden" id="pre-year" role="tabpanel" aria-labelledby="pre-year-tab">
                      <div class="flex justify-center">
                        <span class="text-sm text-slate-400 font-semibold">$</span>
                        <span class="text-3xl font-semibold mx-1">149.99</span>
                        <span class="text-sm text-slate-400 font-semibold self-end">/year</span>
                      </div>
                    </div>
                  </div>

                  <div class="mt-6">
                    <button @click="goToPayment(grille2.id)" class="btn bg-bsd-700/5 hover:bg-bsd-700 border-bsd--blue-700/10 hover:border-bsd--blue-700 text-bsd-700 hover:text-black rounded-md">{{ DataBtn.cart }}</button>
                  </div>
                </div>

                <div class="py-3 px-2 bg-gray-50 dark:bg-slate-800">
                  <p class="text-black mb-0">{{ grille2.texte }} <b class="text-black dark:text-white"></b></p>
                </div>

                <div class="h-40 p-6 border-b border-gray-100 dark:border-gray-700 text-left">
                  <ul class="list-none">
                    <li v-for="contenu in grille2.contenu" class="text-slate-400 my-1">
                      <i class="uil uil-check mr-2 text-emerald-600"></i> <b class="text-black dark:text-white"> {{ contenu.qut }} </b> {{ contenu.type }} pour {{ contenu.mois }} mois
                    </li>
                  </ul>
                </div>

                <!-- <div class="p-4">
                <a href="page-services.html"
                  class="btn btn-link text-bsd-700 hover:text-bsd-700 after:bg-bsd-700 duration-500 ease-in-out">Read
                  More <i class="uil uil-angle-right-b align-middle"></i></a>
              </div> -->

                <div class="p-4 bg-bsd-700">
                  <p class="text-white text-sm">La grille, la plus souvent choisi</p>
                </div>
              </div>
              <!-- End Price Table -->

              <!-- third pricing -->
              <div class="group shadow-sm relative rounded-md overflow-hidden hover:shadow-xl dark:hover:shadow-gray-700 bg-white dark:bg-slate-900 text-center transition-all duration-500 ease-in-out h-fit hover:scale-105">
                <span v-if="grille3.promotion.pourcentage !== 0" class="absolute -right-12 -top-[8px] rotate-[45deg] w-44 h-20 pt-6 px-2 pb-0 flex items-center justify-center text-white bg-amber-500 font-semibold text-sm">
                  Remise de <br />
                  {{ grille3.promotion.pourcentage }} %
                </span>
                <div class="p-6 py-8 border-b border-gray-100 dark:border-gray-700">
                  <h5 class="text-lg font-semibold uppercase">{{ grille3.nom }}</h5>
                  <div class="text-slate-400 mt-4">
                    <b class="text-black dark:text-white"> Type : </b>
                    {{ grille3.type }} <br />{{ grille3.description }}
                  </div>
                </div>

                <div class="p-6 hosting-price">
                  <ul class="flex justify-center space-x-2 text-black dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-full">
                    <li class="inline-block">
                      <button @click="activeTabOne3(grille3.id, grille3.type, 1)" class="px-2 py-1 text-xs font-semibold rounded-full w-full text-slate-400 transition-all duration-500 ease-in-out" :class="{ togleBg: grille3.togle1 }">
                        {{ Month.mois }}
                      </button>
                    </li>
                    <li class="inline-block">
                      <button @click="activeTabTwo3(grille3.id, grille3.type, 3)" class="px-2 py-1 text-xs font-semibold rounded-full w-full text-slate-400 transition-all duration-500 ease-in-out" :class="{ togleBg: grille3.togle2 }">
                        {{ Month.trimestre }}
                      </button>
                    </li>
                    <li class="inline-block">
                      <button @click="activeTabThree3(grille3.id, grille3.type, 6)" class="px-2 py-1 text-xs font-semibold rounded-full w-full text-slate-400 transition-all duration-500 ease-in-out" :class="{ togleBg: grille3.togle3 }">
                        {{ Month.semestre }}
                      </button>
                    </li>
                    <li class="inline-block">
                      <button @click="activeTabFour3(grille3.id, grille3.type, 12)" class="px-2 py-1 text-xs font-semibold rounded-full w-full text-slate-400 transition-all duration-500 ease-in-out" :class="{ togleBg: grille3.togle4 }">
                        {{ Month.year }}
                      </button>
                    </li>
                    <li class="inline-block">
                      <button @click="activeTabFive3(grille3.id, grille3.type, 24)" class="px-2 py-1 text-xs font-semibold rounded-full w-full text-slate-400 transition-all duration-500 ease-in-out" :class="{ togleBg: grille3.togle5 }">
                        {{ Month.twoYear }}
                      </button>
                    </li>
                  </ul>

                  <!-- <ul class="inline-block flex-wrap justify-center text-center p-1 bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-full"
                  id="myTabthree" data-tabs-toggle="#BusinessContent" role="tablist">
                  <li role="presentation" class="inline-block">
                    <button  @click="unMois" class="text-slate-400  px-4 py-1 text-sm font-semibold rounded-full w-full  hover:text-bsd-700 transition-all duration-500 ease-in-out"  :class="{togleBg : togle }"
                      id="busi-month-tab" data-tabs-target="#busi-month" type="button" role="tab"
                      aria-controls="busi-month" aria-selected="true">{{ Month.monthly }}</button>
                  </li>
                  <li role="presentation" class="inline-block">
                    <button
                      class="px-4 py-1 text-sm font-semibold rounded-full w-full text-slate-400 transition-all duration-500 ease-in-out"
                      id="busi-year-tab" data-tabs-target="#busi-year" type="button" role="tab" aria-controls="busi-year"
                      aria-selected="false">{{ Month.trimestre }}</button>
                  </li>
                  <li role="presentation" class="inline-block">
                    <button
                      class="px-4 py-1 text-sm font-semibold rounded-full w-full text-slate-400 transition-all duration-500 ease-in-out"
                      id="busi-year-tab" data-tabs-target="#busi-year" type="button" role="tab" aria-controls="busi-year"
                      aria-selected="false">{{ Month.yearly }}</button>
                  </li>
                  <li role="presentation" class="inline-block">
                    <button
                      class="px-4 py-1 text-sm font-semibold rounded-full w-full text-slate-400 transition-all duration-500 ease-in-out"
                      id="busi-year-tab" data-tabs-target="#busi-year" type="button" role="tab" aria-controls="busi-year"
                      aria-selected="false">{{ Month.yearly }}</button>
                  </li>
                </ul> -->

                  <div id="BusinessContent" class="mt-6">
                    <div class="" id="busi-month" role="tabpanel" aria-labelledby="busi-month-tab">
                      <div class="flex justify-center">
                        <span class="text-sm text-slate-400 font-semibold">{{ Devises.af }}</span>
                        <span v-if="grille3.type == 'kit'" class="text-3xl font-semibold mx-1">{{ prixKiT }} </span>

                        <span v-else-if="grille3.type == 'qr'" class="text-3xl font-semibold mx-1">{{ prixQr }} </span>

                        <span v-else-if="grille3.type == 'tablette'" class="text-3xl font-semibold mx-1">{{ prixTablette2 }} </span> <span class="text-sm text-slate-400 font-semibold self-end">/{{ Month.month }}</span> <br />
                      </div>
                      <!-- <span class="line-through">  {{ prixTablette
                        }}</span>  -->
                    </div>

                    <div class="hidden" id="busi-year" role="tabpanel" aria-labelledby="busi-year-tab">
                      <div class="flex justify-center">
                        <span class="text-sm text-slate-400 font-semibold">{{ Devises.af }}</span>
                        <span class="text-3xl font-semibold mx-1">{{ Price.monthPrice }}</span>
                        <span class="text-sm text-slate-400 font-semibold self-end">/{{ Month.year }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="mt-6">
                    <button @click="goToPayment(grille3.id)" class="btn bg-bsd-700/5 hover:bg-bsd-700 border-bsd--blue-700/10 hover:border-bsd--blue-700 text-bsd-700 hover:text-black rounded-md">{{ DataBtn.cart }}</button>
                  </div>
                </div>

                <div class="py-3 px-2 bg-gray-50 dark:bg-slate-800">
                  <p class="text-black mb-0">{{ grille3.texte }} <b class="text-black dark:text-white"></b></p>
                </div>
                <!-- choice -->
                <div class="h-40 p-6 border-b border-gray-100 dark:border-gray-700 text-left">
                  <ul class="list-none">
                    <li v-for="contenu in grille3.contenu" class="text-slate-400 my-1">
                      <i class="uil uil-check mr-2 text-emerald-600"></i> <b class="text-black dark:text-white"> {{ contenu.qut }} </b> {{ contenu.type }} pour {{ contenu.mois }} mois
                    </li>
                  </ul>
                </div>

                <!-- <div class="p-4">
                <a href="page-services.html"
                  class="btn btn-link text-bsd-700 hover:text-bsd-700 after:bg-bsd-700 duration-500 ease-in-out">Read
                  More <i class="uil uil-angle-right-b align-middle"></i></a>
              </div> -->
              </div>
              <!-- End Price Table -->
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import GrilleTarifaireService from "@/services/modules/grilleTarifaire.service";
import PackService from "@/services/modules/pack.service";

export default {
  name: "Pricing",
  data() {
    return {
      Devises: {
        af: "XOF",
        ac: "XAF",
        e: "€",
        d: "$",
      },
      DataBtn: {
        cart: "Je prends cette grille tarifaire",
      },
      Month: {
        monthly: "1 mois",
        month: "Mois",
        yearly: "Annuel",
        year: "12 mois",
        mois: " 1 mois",
        trimestre: "3 mois",
        semestre: "6 mois",
        twoYear: "24 mois",
      },
      Pack: {
        nameFirst: "QR LINK",
        nameSecond: "Comptoir",
        nameThird: "Stand Touch",
      },
      grille1: {
        type: "",
        promotion: [],
        prix: "",
        description: "",
        texte: "",
        contenu: [],
        togle1: true,
        togle2: false,
        togle3: false,
        togle4: false,
        togle5: false,
        id: "",
        nom: "",
      },
      grille2: {
        type: "",
        promotion: [],
        prix: "",
        description: "",
        texte: "",
        contenu: [],
        togle1: true,
        togle2: false,
        togle3: false,
        togle4: false,
        togle5: false,
        id: "",
        nom: "",
      },
      grille3: {
        type: "",
        promotion: [],
        prix: "",
        description: "",
        texte: "",
        contenu: [],
        togle1: true,
        togle2: false,
        togle3: false,
        togle4: false,
        togle5: false,
        id: "",
        nom: "",
      },
      Price: {
        monthPrice: 35500,
        yearPrice: 42500,
      },
      togleBg: "togleBg",
      tab: 1,
      prixKiT: "",
      prixQr: "",
      prixTablette: "",
      prixKiT2: "",
      prixQr2: "",
      prixTablette2: "",
      nbreDeGrille: Number,
      grilleMonthId: "",
    };
  },

  beforeMount() {
    this.getGrilleTarifaire();
  },

  mounted() {
    this.activeTabOne1(this.grille1.id, "kit", 1);
    this.activeTabOne2(this.grille2.id, "qr", 1);
    this.activeTabOne3(this.grille3.id, "tablette", 1);
    // this.getgrille()
  },
  methods: {
    getGrilleTarifaire() {
      GrilleTarifaireService.get()
        .then((response) => {
          let tabGrille = response.data.data;

          this.grille1.type = tabGrille[0].type;
          this.grille1.prix = tabGrille[0].prix;
          this.grille1.promotion = tabGrille[0].promotion;
          this.grille1.id = tabGrille[0].id;
          this.grille1.description = tabGrille[0].description;
          this.grille1.texte = tabGrille[0].texte;
          this.grille1.nom = tabGrille[0].nom;

          this.grille2.type = tabGrille[1].type;
          this.grille2.prix = tabGrille[1].prix;
          this.grille2.promotion = tabGrille[1].promotion;
          this.grille2.id = tabGrille[1].id;
          this.grille2.description = tabGrille[1].description;
          this.grille2.texte = tabGrille[1].texte;
          this.grille2.nom = tabGrille[1].nom;

          this.grille3.type = tabGrille[2].type;
          this.grille3.prix = tabGrille[2].prix;
          this.grille3.promotion = tabGrille[2].promotion;
          this.grille3.id = tabGrille[2].id;
          this.grille3.description = tabGrille[2].description;
          this.grille3.texte = tabGrille[2].texte;
          this.grille3.nom = tabGrille[2].nom;
        })
        .catch((e) => {});
    },

    goToPayment(id) {
      if (this.grilleMonthId) {
        this.$router.push({ name: "GrillePayment", params: { id: this.grilleMonthId } });
      } else {
        this.$router.push({ name: "GrillePayment", params: { id: id } });
      }

      // this.$router.push({ name: 'questionnaire_id_details', params: { id: index, questionnaire: data } })
    },

    // filtre

    getPrice(grille, typeGrille, dureemois) {
      let formData = {
        type: typeGrille,
        mois: dureemois,
      };

      GrilleTarifaireService.getPrice(formData)
        .then((response) => {
          let tab = response.data.data;

          if (dureemois > 1) {
            this.grilleMonthId = tab[0].id;
          }

          if (tab[0].type == "kit") {
            if (tab[0].promotion.pourcentage > 0) {
              this.prixKiT2 = tab[0].prix * (1 - tab[0].promotion.pourcentage / 100);
              this.prixKiT = tab[0].prix;
            } else {
              this.prixKiT = tab[0].prix;
            }
          } else if (tab[0].type == "tablette") {
            if (tab[0].promotion.pourcentage > 0) {
              this.prixTablette2 = tab[0].prix * (1 - tab[0].promotion.pourcentage / 100);
              this.prixTablette = tab[0].prix;
            } else {
              this.prixTablette = tab[0].prix;
            }
          } else if (tab[0].type == "qr") {
            if (tab[0].promotion.pourcentage > 0) {
              this.prixQr2 = tab[0].prix * (1 - tab[0].promotion.pourcentage / 100);
              this.prixQr = tab[0].prix;
            } else {
              this.prixQr = tab[0].prix;
            }
          }
        })
        .catch((e) => {});
    },

    // grille trois

    activeTabOne3(id, type, mois) {
      if (type == "kit") {
        type = 1;
      } else if (type == "tablette") {
        type = 3;
      } else if (type == "qr") {
        type = 2;
      }

      this.grilleMonthId = this.grille1.id;

      this.tab = 1;
      this.grille3.togle1 = true;
      this.grille3.togle2 = false;
      this.grille3.togle3 = false;
      this.grille3.togle4 = false;
      this.grille3.togle5 = false;

      this.getPrice(id, type, mois);
    },
    activeTabTwo3(id, type, mois) {
      if (type == "kit") {
        type = 1;
      } else if (type == "tablette") {
        type = 3;
      } else if (type == "qr") {
        type = 2;
      }

      this.tab = 2;
      this.grille3.togle1 = false;
      this.grille3.togle2 = true;
      this.grille3.togle3 = false;
      this.grille3.togle4 = false;
      this.grille3.togle5 = false;
      this.getPrice(id, type, mois);
    },

    activeTabThree3(id, type, mois) {
      if (type == "kit") {
        type = 1;
      } else if (type == "tablette") {
        type = 3;
      } else if (type == "qr") {
        type = 2;
      }

      this.tab = 3;
      this.grille3.togle1 = false;
      this.grille3.togle2 = false;
      this.grille3.togle3 = true;
      this.grille3.togle4 = false;
      this.grille3.togle5 = false;
      this.getPrice(id, type, mois);
    },

    activeTabFour3(id, type, mois) {
      if (type == "kit") {
        type = 1;
      } else if (type == "tablette") {
        type = 3;
      } else if (type == "qr") {
        type = 2;
      }

      this.tab = 4;
      this.grille3.togle1 = false;
      this.grille3.togle2 = false;
      this.grille3.togle3 = false;
      this.grille3.togle4 = true;
      this.grille3.togle5 = false;
      this.getPrice(id, type, mois);
    },
    activeTabFive3(id, type, mois) {
      if (type == "kit") {
        type = 1;
      } else if (type == "tablette") {
        type = 3;
      } else if (type == "qr") {
        type = 2;
      }

      this.tab = 5;

      this.grille3.togle1 = false;
      this.grille3.togle2 = false;
      this.grille3.togle3 = false;
      this.grille3.togle4 = false;
      this.grille3.togle5 = true;
      this.getPrice(id, type, mois);
    },

    // grille 1

    activeTabOne1(id, type, mois) {
      if (type == "kit") {
        type = 1;
      } else if (type == "tablette") {
        type = 3;
      } else if (type == "qr") {
        type = 2;
      }

      this.grilleMonthId = this.grille1.id;

      this.tab = 1;
      this.grille1.togle1 = true;
      this.grille1.togle2 = false;
      this.grille1.togle3 = false;
      this.grille1.togle4 = false;
      this.grille1.togle5 = false;
      this.getPrice(id, type, mois);
    },
    activeTabTwo1(id, type, mois) {
      if (type == "kit") {
        type = 1;
      } else if (type == "tablette") {
        type = 3;
      } else if (type == "qr") {
        type = 2;
      }

      this.tab = 2;
      this.grille1.togle1 = false;
      this.grille1.togle2 = true;
      this.grille1.togle3 = false;
      this.grille1.togle4 = false;
      this.grille1.togle5 = false;

      this.getPrice(id, type, mois);
    },
    activeTabThree1(id, type, mois) {
      if (type == "kit") {
        type = 1;
      } else if (type == "tablette") {
        type = 3;
      } else if (type == "qr") {
        type = 2;
      }

      this.tab = 3;
      this.grille1.togle1 = false;
      this.grille1.togle2 = false;
      this.grille1.togle3 = true;
      this.grille1.togle4 = false;
      this.grille1.togle5 = false;

      this.getPrice(id, type, mois);
    },
    activeTabFour1(id, type, mois) {
      if (type == "kit") {
        type = 1;
      } else if (type == "tablette") {
        type = 3;
      } else if (type == "qr") {
        type = 2;
      }

      this.tab = 4;
      this.grille1.togle1 = false;
      this.grille1.togle2 = false;
      this.grille1.togle3 = false;
      this.grille1.togle4 = true;
      this.grille1.togle5 = false;

      this.getPrice(id, type, mois);
    },
    activeTabFive1(id, type, mois) {
      if (type == "kit") {
        type = 1;
      } else if (type == "tablette") {
        type = 3;
      } else if (type == "qr") {
        type = 2;
      }

      this.tab = 5;
      this.grille1.togle1 = false;
      this.grille1.togle2 = false;
      this.grille1.togle3 = false;
      this.grille1.togle4 = false;
      this.grille1.togle5 = true;

      this.getPrice(id, type, mois);
    },

    // grille2

    activeTabOne2(id, type, mois) {
      if (type == "kit") {
        type = 1;
      } else if (type == "tablette") {
        type = 3;
      } else if (type == "qr") {
        type = 2;
      }
      this.grilleMonthId = this.grille1.id;

      this.tab = 1;
      this.grille2.togle1 = true;
      this.grille2.togle2 = false;
      this.grille2.togle3 = false;
      this.grille2.togle4 = false;
      this.grille2.togle5 = false;

      this.getPrice(id, type, mois);
    },
    activeTabTwo2(id, type, mois) {
      if (type == "kit") {
        type = 1;
      } else if (type == "tablette") {
        type = 3;
      } else if (type == "qr") {
        type = 2;
      }

      this.tab = 2;
      this.grille2.togle1 = false;
      this.grille2.togle2 = true;
      this.grille2.togle3 = false;
      this.grille2.togle4 = false;
      this.grille2.togle5 = false;

      this.getPrice(id, type, mois);
    },
    activeTabThree2(id, type, mois) {
      if (type == "kit") {
        type = 1;
      } else if (type == "tablette") {
        type = 3;
      } else if (type == "qr") {
        type = 2;
      }

      this.tab = 3;
      this.grille2.togle1 = false;
      this.grille2.togle2 = false;
      this.grille2.togle3 = true;
      this.grille2.togle4 = false;
      this.grille2.togle5 = false;

      this.getPrice(id, type, mois);
    },
    activeTabFour2(id, type, mois) {
      if (type == "kit") {
        type = 1;
      } else if (type == "tablette") {
        type = 3;
      } else if (type == "qr") {
        type = 2;
      }

      this.tab = 4;
      this.grille2.togle1 = false;
      this.grille2.togle2 = false;
      this.grille2.togle3 = false;
      this.grille2.togle4 = true;
      this.grille2.togle5 = false;
      type, mois;

      this.getPrice(id, type, mois);
    },
    activeTabFive2(id, type, mois) {
      if (type == "kit") {
        type = 1;
      } else if (type == "tablette") {
        type = 3;
      } else if (type == "qr") {
        type = 2;
      }

      this.tab = 5;
      this.grille2.togle1 = false;
      this.grille2.togle2 = false;
      this.grille2.togle3 = false;
      this.grille2.togle4 = false;
      this.grille2.togle5 = true;

      this.getPrice(id, type, mois);
    },
  },
};
</script>

<style scoped>
.togleBg {
  background-color: #1a365e;
  color: white;
}

.section {
  padding: 2em 0;
}

.fade-up-enter-active,
.fade-up-leave-active {
  transition: all 0.3s ease-in-out;
}

.fade-up-enter,
.fade-up-leave-to {
  height: 0;
  transform: translateY(30px);
  opacity: 0;
}

.custom-bg {
  background: #ff0000;
}

.bgBlack {
  background: rgba(0, 0, 0, 0.302);
}

.bg-blacks {
  background-color: rgba(0, 0, 0, 0.264);
}

.myModal {
  padding: 20px;
  width: 300 px;
  height: auto;
  border-radius: 6px;
  border: 1px solid #1a365e;
  width: 40%;
}

.form-control {
  width: 100%;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  border: 1px solid rgb(226, 232, 240);
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  outline-offset: 1px;
  outline-style: solid 6px rgb(226, 232, 240);
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
}
</style>
